import { Check, ArrowUpRight, Phone } from "lucide-react";
import { useLang } from "../../i18n";
import { scrollTo } from "../../utils";
import { Reveal, SectionHead } from "./Section";

const Process = () => {
  const { t } = useLang();
  return (
    <section id="qualite" className="border-y border-[#232733] bg-[#111318] scroll-mt-16" data-testid="process-section">
      <div className="px-6 lg:px-12 py-20 lg:py-32">
        <SectionHead index="07" overline={t.process.overline} title={t.process.title} desc={t.process.desc} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#232733] border border-[#232733] mt-14">
          {t.process.steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.08} className="bg-[#0A0B0E]">
              <div className="p-8 h-full group hover:bg-[#1A1D24] transition-colors" data-testid={`process-step-${i}`}>
                <span className="font-display text-5xl font-extrabold tracking-tighter text-[#232733] group-hover:text-[#0055FF] transition-colors">
                  {s.n}
                </span>
                <h3 className="font-display text-xl font-medium tracking-tight text-white mt-6">{s.title}</h3>
                <p className="text-sm text-[#A0AABF] mt-3 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-3 mt-10">
          {t.process.checks.map((c, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.15em] text-[#A0AABF] border border-[#232733] px-4 py-2" data-testid={`process-check-${i}`}>
                <Check size={12} className="text-[#0055FF]" /> {c}
              </span>
            </Reveal>
          ))}
        </div>
        <div className="flex flex-wrap gap-2 mt-6">
          {t.process.markets.map((m, i) => (
            <span key={i} className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4D8BFF] border border-[#0055FF]/30 px-4 py-2" data-testid={`market-${i}`}>
              {m}
            </span>
          ))}
        </div>
      </div>

      <div className="border-t border-[#232733] px-6 lg:px-12 py-20 lg:py-28 relative overflow-hidden noise-overlay">
        <div className="absolute inset-0 blueprint-grid pointer-events-none" />
        <Reveal className="relative z-10 max-w-3xl">
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-[#FF4D00]" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#647087]">{t.process.cta.overline}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter text-white mt-6 leading-[0.95]">
            {t.process.cta.title}
          </h2>
          <p className="text-base md:text-lg text-[#A0AABF] mt-6 leading-relaxed">{t.process.cta.desc}</p>
          <div className="flex flex-wrap gap-4 mt-10">
            <button
              data-testid="cta-quote-btn"
              onClick={() => scrollTo("#devis")}
              className="group flex items-center gap-3 bg-[#FF4D00] text-white font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-[#0055FF] transition-colors"
            >
              {t.process.cta.primary}
              <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
            <a
              data-testid="cta-call-btn"
              href={`tel:${t.phone1.replace(/\s/g, "")}`}
              className="flex items-center gap-3 border border-[#232733] text-white font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 hover:border-[#0055FF] hover:text-[#4D8BFF] transition-colors"
            >
              {t.process.cta.secondary}
              <Phone size={16} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Process;
